<template>
  <Header :title="$t('userManagement.title')" />

  <div class="userManagementContainer">
    <div class="pageContainerJob">
      <!-- Back Header -->
      <div class="createUserHeader">
        <svg @click="handleBackToUsers" style="cursor: pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
          <path d="M5.25 11.25H20.25C20.45 11.25 20.64 11.33 20.78 11.47C20.92 11.61 21 11.8 21 12C21 12.2 20.92 12.39 20.78 12.53C20.64 12.67 20.45 12.75 20.25 12.75H5.25C5.05 12.75 4.86 12.67 4.72 12.53C4.58 12.39 4.5 12.2 4.5 12C4.5 11.8 4.58 11.61 4.72 11.47C4.86 11.33 5.05 11.25 5.25 11.25Z" fill="black" />
          <path d="M5.56 12L11.78 18.22C11.92 18.36 12 18.55 12 18.75C12 18.95 11.92 19.14 11.78 19.28C11.64 19.42 11.45 19.5 11.25 19.5C11.05 19.5 10.86 19.42 10.72 19.28L3.97 12.53C3.9 12.46 3.84 12.38 3.81 12.29C3.77 12.2 3.75 12.1 3.75 12C3.75 11.9 3.77 11.8 3.81 11.71C3.84 11.62 3.9 11.54 3.97 11.47L10.72 4.72C10.86 4.58 11.05 4.5 11.25 4.5C11.45 4.5 11.64 4.58 11.78 4.72C11.92 4.86 12 5.05 12 5.25C12 5.45 11.92 5.64 11.78 5.78L5.56 12Z" fill="black" />
        </svg>
        <span class="newPageTitle">{{ $t('userManagement.pages.create.title') }}</span>
      </div>

      <div class="createUserBody">
        <div class="form-field">
          <label>{{ $t('userManagement.forms.labels.roles') }}</label>
          <select v-model="selectedRoleId">
            <option disabled value="">{{ $t('userManagement.forms.placeholders.select_role') }}</option>
            <option v-for="role in roles" :key="role.id" :value="role.id">
              {{ role.roleName }}
            </option>
          </select>
          <div v-if="fieldErrors.roleId" class="field-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.8666C9.55585 13.8666 11.0481 13.2485 12.1483 12.1483C13.2485 11.0481 13.8666 9.55585 13.8666 7.99992C13.8666 6.44398 13.2485 4.95177 12.1483 3.85156C11.0481 2.75135 9.55585 2.13325 7.99992 2.13325C6.44398 2.13325 4.95177 2.75135 3.85156 3.85156C2.75135 4.95177 2.13325 6.44398 2.13325 7.99992C2.13325 9.55585 2.75135 11.0481 3.85156 12.1483C4.95177 13.2485 6.44398 13.8666 7.99992 13.8666ZM7.55992 4.28725H8.43992L8.38058 8.99392H7.61992L7.56125 4.28725H7.55992ZM7.99992 11.3819C7.92657 11.3828 7.85378 11.369 7.78584 11.3414C7.7179 11.3137 7.65617 11.2727 7.6043 11.2209C7.55243 11.169 7.51146 11.1073 7.4838 11.0393C7.45614 10.9714 7.44236 10.8986 7.44325 10.8253C7.44189 10.7518 7.45537 10.6788 7.48286 10.6106C7.51036 10.5425 7.55131 10.4806 7.60327 10.4286C7.65524 10.3766 7.71715 10.3357 7.7853 10.3082C7.85345 10.2807 7.92644 10.2672 7.99992 10.2686C8.31725 10.2686 8.55658 10.5086 8.55658 10.8253C8.55794 10.8987 8.54447 10.9717 8.51698 11.0399C8.48948 11.108 8.44853 11.1699 8.39656 11.2219C8.3446 11.2739 8.28269 11.3148 8.21454 11.3423C8.14639 11.3698 8.07339 11.3833 7.99992 11.3819Z" fill="#E50006" stroke="#E50006" stroke-width="0.2" />
            </svg>
            {{ fieldErrors.roleId }}
          </div>
        </div>
        <div class="form-field" v-if="selectedRoleId && selectedRoleId !== 2">
          <label>{{ $t('userManagement.forms.labels.tenant') }}</label>
          <select v-model="selectedTenantId">
            <option disabled value="">{{ $t('userManagement.forms.placeholders.select_tenant') }}</option>
            <option v-for="tenant in tenants" :key="tenant.id" :value="tenant.id">
              {{ tenant.tenant_name }}
            </option>
          </select>
          <div v-if="fieldErrors.tenantId" class="field-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.8666C9.55585 13.8666 11.0481 13.2485 12.1483 12.1483C13.2485 11.0481 13.8666 9.55585 13.8666 7.99992C13.8666 6.44398 13.2485 4.95177 12.1483 3.85156C11.0481 2.75135 9.55585 2.13325 7.99992 2.13325C6.44398 2.13325 4.95177 2.75135 3.85156 3.85156C2.75135 4.95177 2.13325 6.44398 2.13325 7.99992C2.13325 9.55585 2.75135 11.0481 3.85156 12.1483C4.95177 13.2485 6.44398 13.8666 7.99992 13.8666ZM7.55992 4.28725H8.43992L8.38058 8.99392H7.61992L7.56125 4.28725H7.55992ZM7.99992 11.3819C7.92657 11.3828 7.85378 11.369 7.78584 11.3414C7.7179 11.3137 7.65617 11.2727 7.6043 11.2209C7.55243 11.169 7.51146 11.1073 7.4838 11.0393C7.45614 10.9714 7.44236 10.8986 7.44325 10.8253C7.44189 10.7518 7.45537 10.6788 7.48286 10.6106C7.51036 10.5425 7.55131 10.4806 7.60327 10.4286C7.65524 10.3766 7.71715 10.3357 7.7853 10.3082C7.85345 10.2807 7.92644 10.2672 7.99992 10.2686C8.31725 10.2686 8.55658 10.5086 8.55658 10.8253C8.55794 10.8987 8.54447 10.9717 8.51698 11.0399C8.48948 11.108 8.44853 11.1699 8.39656 11.2219C8.3446 11.2739 8.28269 11.3148 8.21454 11.3423C8.14639 11.3698 8.07339 11.3833 7.99992 11.3819Z" fill="#E50006" stroke="#E50006" stroke-width="0.2" />
            </svg>
            {{ fieldErrors.tenantId }}
          </div>
        </div>

        <div class="form-field">
          <label>{{ $t('userManagement.forms.labels.email') }}</label>
          <input type="email" v-model="email" :placeholder="$t('userManagement.forms.placeholders.user_email')" />
          <div v-if="fieldErrors.email" class="field-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.8666C9.55585 13.8666 11.0481 13.2485 12.1483 12.1483C13.2485 11.0481 13.8666 9.55585 13.8666 7.99992C13.8666 6.44398 13.2485 4.95177 12.1483 3.85156C11.0481 2.75135 9.55585 2.13325 7.99992 2.13325C6.44398 2.13325 4.95177 2.75135 3.85156 3.85156C2.75135 4.95177 2.13325 6.44398 2.13325 7.99992C2.13325 9.55585 2.75135 11.0481 3.85156 12.1483C4.95177 13.2485 6.44398 13.8666 7.99992 13.8666ZM7.55992 4.28725H8.43992L8.38058 8.99392H7.61992L7.56125 4.28725H7.55992ZM7.99992 11.3819C7.92657 11.3828 7.85378 11.369 7.78584 11.3414C7.7179 11.3137 7.65617 11.2727 7.6043 11.2209C7.55243 11.169 7.51146 11.1073 7.4838 11.0393C7.45614 10.9714 7.44236 10.8986 7.44325 10.8253C7.44189 10.7518 7.45537 10.6788 7.48286 10.6106C7.51036 10.5425 7.55131 10.4806 7.60327 10.4286C7.65524 10.3766 7.71715 10.3357 7.7853 10.3082C7.85345 10.2807 7.92644 10.2672 7.99992 10.2686C8.31725 10.2686 8.55658 10.5086 8.55658 10.8253C8.55794 10.8987 8.54447 10.9717 8.51698 11.0399C8.48948 11.108 8.44853 11.1699 8.39656 11.2219C8.3446 11.2739 8.28269 11.3148 8.21454 11.3423C8.14639 11.3698 8.07339 11.3833 7.99992 11.3819Z" fill="#E50006" stroke="#E50006" stroke-width="0.2" />
            </svg>
            {{ fieldErrors.email }}
          </div>
        </div>

        <div class="button-group">
          <button class="cancel-btn" @click="cancel">{{ $t('userManagement.buttons.cancel') }}</button>
          <button class="invite-btn" @click="inviteUser">{{ $t('userManagement.pages.create.invite_button') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import { post, get } from '@/utils/api'
import { showToast } from '@/utils/toast'

export default {
  components: {
    Header,
  },
  data() {
    return {
      tenants: [],
      roles: [],
      selectedTenantId: '',
      selectedRoleId: '',
      email: '',
      loading: false,
      fieldErrors: {
        email: '',
        tenantId: '',
        roleId: '',
      },
    }
  },
  mounted() {
    document.title = 'Create User'
    this.fetchTenants()
    this.fetchRoles()
  },
  methods: {
    async fetchTenants() {
      this.loading = true
      try {
        const res = await get('/v1/tenants?page=1&pageSize=1000000')
        if (res?.data?.code === 200) {
          this.tenants = res.data.data.tenants || []
        }
      } catch (err) {
      } finally {
        this.loading = false
      }
    },
    async fetchRoles() {
      this.loading = true
      try {
        const res = await get('/v1/roles')
        if (res?.data?.code === 200) {
          this.roles = res.data.data.roles?.filter((role) => role.roleName !== 'SYSTEM ROLE') || []
        }
      } catch (err) {
      } finally {
        this.loading = false
      }
    },
    async inviteUser() {
      this.loading = true
      if (this.selectedRoleId !== 2 && !this.selectedTenantId) {
        this.fieldErrors.tenantId = this.$t('userManagement.forms.validation.tenant_required')
      } else {
        this.fieldErrors.tenantId = ''
      }
      if (!this.selectedRoleId) {
        this.fieldErrors.roleId = this.$t('userManagement.forms.validation.role_required')
      } else {
        this.fieldErrors.roleId = ''
      }

      if (!this.email) {
        this.fieldErrors.email = this.$t('userManagement.forms.validation.email_required')
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.fieldErrors.email = this.$t('userManagement.forms.validation.email_invalid')
      } else {
        this.fieldErrors.email = ''
      }
      if (this.fieldErrors.email || this.fieldErrors.tenantId || this.fieldErrors.roleId) return
      try {
        const res = await post('/auth/register', {
          email: this.email,
          password: 'Password@123',
          tenantId: this.selectedTenantId || 2,
          roleIds: [this.selectedRoleId],
        })

        if (res?.data?.code === 200) {
          showToast({
            title: this.$t('userManagement.messages.operation_successful'),
            message: this.$t('userManagement.messages.success.user_created'),
            type: 'success',
          })
          const tenantName = localStorage.getItem('url_name')
          this.$router.push(`/${tenantName}/users-management`)
        } else {
          showToast({
            title: this.$t('userManagement.messages.operation_failed'),
            message: this.$t('userManagement.messages.error.create_failed'),
            type: 'error',
          })
        }
      } catch (err) {
        if (err?.response?.data?.message?.includes('duplicate key value violates unique constraint "uni_users_email_id"')) {
          showToast({
            title: this.$t('userManagement.messages.operation_failed'),
            message: this.$t('userManagement.messages.error.duplicate_email'),
            type: 'error',
            duration: 3000,
          })
        } else {
          showToast({
            title: this.$t('userManagement.messages.operation_failed'),
            message: this.$t('userManagement.messages.error.create_retry'),
            type: 'error',
            duration: 3000,
          })
        }
      } finally {
        this.loading = false
      }
    },
    cancel() {
      const tenantName = localStorage.getItem('url_name')
      this.$router.push(`/${tenantName}/users-management`)
    },
    validateForm() {
      let isValid = true

      // Validate role first
      if (!this.selectedRoleId) {
        this.fieldErrors.roleId = 'Role is required.'
        isValid = false
      } else {
        this.fieldErrors.roleId = ''
      }

      // Only validate tenant if role is not 2
      if (this.selectedRoleId !== 2) {
        if (!this.selectedTenantId) {
          this.fieldErrors.tenantId = 'Tenant is required.'
          isValid = false
        } else {
          this.fieldErrors.tenantId = ''
        }
      }

      // ... rest of validation ...
      return isValid
    },
    handleRoleChange() {
      if (this.selectedRoleId === 2) {
        this.selectedTenantId = ''
        this.fieldErrors.tenantId = ''
      }
    },
    handleBackToUsers() {
      const tenantName = localStorage.getItem('url_name')
      this.$router.push(`/${tenantName}/users-management`)
    },
  },
  watch: {
    selectedRoleId(newValue) {
      this.handleRoleChange()
    },
  },
}
</script>

<style scoped>
.createUserHeader {
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 9px;
}

.newPageTitle {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 28px;
  font-weight: 500;
  line-height: 150%;
}

.createUserBody {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.form-field label {
  color: #8b8888;
  font-family: Archivo;
  font-size: 18px;
  font-weight: 400;
  display: block;
  margin-bottom: 6px;
}

.form-field input,
.form-field select {
  width: 579px;
  height: 47px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #dbdbdb;
  font-family: Archivo;
  font-size: 16px;
  color: #32393e;
}

.button-group {
  margin-top: 20px;
  display: flex;
  gap: 20px;
}

.cancel-btn {
  padding: 10px 32px;
  background: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  font-family: Archivo;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
}

.invite-btn {
  padding: 10px 32px;
  background: var(--primary-color);
  color: white;
  font-family: Archivo;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
</style>
